import { AES, enc, mode } from "crypto-js";
import { Buffer } from "buffer";
import globalConfig from '../config/global/config.json';

export const parseQueryParameters = () => {
    const params = getParamsFromUrl();
    const sStorage = storeUrlParameters(); 
    if (!params.update) {
        const utmParams = getUtmParamsFromUrl(params);
        let redirectParam = '?update=true';
        if (utmParams && Object.keys(utmParams).length > 0) {
            const queryParams = new URLSearchParams(utmParams).toString();
            redirectParam = redirectParam + `&${queryParams}`;
        }
        sStorage.clear();
        params ? sStorage.set(params) : sStorage.clear();
        sessionStorage.setItem('errorPath', window.location.pathname+window.location.search);
        window.history.replaceState({}, document.title, window.location.pathname+redirectParam);
    }
}

const getParamsFromUrl = () => {
    let paramsFromUrl = getUrlParameters(window.location.search.substring(1));
    if (paramsFromUrl.nid) {
        const key = createKey();
        const b64_key = Buffer.from(key, 'binary').toString('base64');
        const decryptedUrlSearch = decryptURLParams(paramsFromUrl.nid, b64_key);
        const decryptedParams = decryptedUrlSearch ? getUrlParameters(decryptedUrlSearch) : { decryptionFailure: true };
        delete paramsFromUrl.nid;
        return Object.keys(paramsFromUrl).length > 0 ? { ...paramsFromUrl, ...decryptedParams } : decryptedParams;
    }
    return paramsFromUrl;
}

const decryptURLParams = (nid, b64_key) => {
    let stringUrlSearch;
    try {
        const arrayBuffer = base64ToArrayBuffer(nid);
        const iv = enc.Base64.parse(arrayBufferToBase64(arrayBuffer.slice(0, 16)));
        const encryptedStr = arrayBufferToBase64(arrayBuffer.slice(16, arrayBuffer.byteLength));
        const aes_options = {
            iv: iv,
            mode: mode.CBC
        };
        const decryptedURLSearch = AES.decrypt(
            encryptedStr, 
            enc.Base64.parse(b64_key),
            aes_options
            );
        stringUrlSearch = decryptedURLSearch.toString(enc.Utf8);
    } catch {
        stringUrlSearch = false;
    }
    return stringUrlSearch;
}

const createKey = () => {
    const countryCode = window.location.pathname.split('-')[1];
    return ((countryCode ? countryCode.toUpperCase() : '') + window.location.host).slice(0, 32);
}

const base64ToArrayBuffer = base64 => {
    const binary_string = Buffer.from(base64, 'base64').toString('binary');
    const len = binary_string.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
        bytes[i] = binary_string.charCodeAt(i);
    }
    return bytes.buffer;
};

const arrayBufferToBase64 = arrayBuffer => {
    return Buffer.from(
        new Uint8Array(arrayBuffer).reduce((data, byte) => {
                return data + String.fromCharCode(byte)
            },''), 'binary'
    ).toString('base64');
};

const isValidParams = (param) => {
  return globalConfig.SET_ALLOWED_PARAMS.includes(param)
}

const getUrlParameters = function (searchParams) {
    let parameters = {};
    let urlParams = searchParams.split("&");
    for (let i = 0; i < urlParams.length; i++) {
        const [key, ...value] = urlParams[i].split('=');
        if (!isValidParams(key)) {
            continue;
        }
        parameters[key] = value.join('=');
    }
    return parameters;
}

const getUtmParamsFromUrl = (params) => {
    const utmEntries = Object.entries(params).filter(([key]) => key.includes('utm'));
    const utmObject = Object.fromEntries(utmEntries);
    utmEntries.forEach(([key]) => {
      delete params[key];
    });
    return utmObject;
}

const storeUrlParameters = function() {
    const clearData = () => {
        let keys = Object.keys(sessionStorage);
        for (let i=0;i<keys.length;i++) {
            let key = keys[i];
            if (key!=="isVerified") {
                sessionStorage.removeItem(key)
            }
        }
    }
    const setData = (data) => {
        Object.entries(data).forEach(([key, value]) => {
            key && value && sessionStorage.setItem([key], [value]);
        });
    }
    const getData = () => Object.keys(sessionStorage).map(i=>{return {[i]: sessionStorage.getItem(i)}});
    return {
        set: setData,
        get: getData,
        clear: clearData
    }
}